enum NonBenefitSymptomId {
  Hairloss = '9',
  Acne = '11',
  Diet = '12',
  GongJinDan = '109',
  OrientalBeauty = '605',
  OtherOrientalTreatments = '610',
}

export enum DepreactedCategoryType {
  Symptom = 'symptom',
  Subject = 'subject',
}

export enum CategoryType {
  Treatment = 'treatment',
  Department = 'department',
}

export default class DiagnosisCategoryService {
  static getDiagnosisCategoryType = (
    deprecatedType: DepreactedCategoryType,
  ): CategoryType => {
    switch (deprecatedType) {
      case DepreactedCategoryType.Subject:
        return CategoryType.Department;
      case DepreactedCategoryType.Symptom:
        return CategoryType.Treatment;
    }
  };

  static getDeprecatedCategoryType = (
    categoryType: CategoryType,
  ): DepreactedCategoryType => {
    switch (categoryType) {
      case CategoryType.Department:
        return DepreactedCategoryType.Subject;
      case CategoryType.Treatment:
        return DepreactedCategoryType.Symptom;
    }
  };

  static isNonBenefitCategory(
    type?: CategoryType,
    categoryId?: string,
  ): boolean {
    if (!type || !categoryId) {
      return false;
    }
    switch (type) {
      case CategoryType.Treatment: {
        switch (categoryId) {
          case NonBenefitSymptomId.Hairloss:
          case NonBenefitSymptomId.Acne:
          case NonBenefitSymptomId.Diet:
          case NonBenefitSymptomId.GongJinDan:
          case NonBenefitSymptomId.OrientalBeauty:
          case NonBenefitSymptomId.OtherOrientalTreatments:
            return true;
          default:
            return false;
        }
      }
      case CategoryType.Department: {
        return false;
      }
    }
  }
}
